import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type RouterLayoutContextData_BasicLayout_Fragment = (
  { __typename: 'BasicLayout' }
  & Pick<SchemaTypes.BasicLayout, 'withAdminButton'>
);

export type RouterLayoutContextData_BasicProLayout_Fragment = (
  { __typename: 'BasicProLayout' }
  & Pick<SchemaTypes.BasicProLayout, 'withSignInButton' | 'layoutMode' | 'navigationTheme'>
);

export type RouterLayoutContextDataFragment = RouterLayoutContextData_BasicLayout_Fragment | RouterLayoutContextData_BasicProLayout_Fragment;

export const RouterLayoutContextDataFragmentDoc = /*#__PURE__*/ gql`
    fragment RouterLayoutContextData on Layout {
  __typename
  ... on BasicLayout {
    withAdminButton
  }
  ... on BasicProLayout {
    withSignInButton
    layoutMode
    navigationTheme
  }
}
    `;